export const buttonGetHoverProps = (color: string): Toolkit.Theme.Button["defaultProps"] => ({
    hoverStyle: { color },
    activeStyle: { color },
});

export const buttonGetColorProps = (
    color: string,
    hoverColor?: string,
    hoverTextColor?: string,
): Toolkit.Theme.Button["defaultProps"] => ({
    color,
    ...buttonGetHoverProps(hoverColor || color),
    hoverTextColor,
});
